module.exports = __webpack_public_path__ + "img/send-msg.2cefb7c7.png";